import React from "react";

export interface ChatBoxViewContextType {
	toUidInfo: {
		uid: string;
		name: string;
		avatarUrl: string;
		accessTimeInfo: string;
	};
	fromUidInfo: {
		uid: string;
		name: string;
		avatarUrl: string;
	};
}

export const ChatBoxViewContext = React.createContext<ChatBoxViewContextType>({
	toUidInfo: {
		uid: "",
		name: "",
		avatarUrl: "",
		accessTimeInfo: "",	
	},
	fromUidInfo: {
		uid: "",
		name: "",
		avatarUrl: "",
	},
});

export interface ChatBoxViewProviderProps {
	toUidInfo: ChatBoxViewContextType["toUidInfo"];
	fromUidInfo: ChatBoxViewContextType["fromUidInfo"];
	children?: React.ReactNode;
}

export const ChatBoxViewProvider = ({ children, toUidInfo, fromUidInfo }: ChatBoxViewProviderProps) => {
	return (
		<ChatBoxViewContext.Provider value={{ toUidInfo, fromUidInfo }}>
			{children}
		</ChatBoxViewContext.Provider>
	);
};

export const useChatBoxViewContext = () => {
	return React.useContext(ChatBoxViewContext);
};
